'use client';
import React from 'react';

const stats = [
  { value: '50K+', label: 'Happy customers', color: '#f97316' },
  { value: '1,200+', label: 'Local vendors', color: '#f97316' },
  { value: '18 min', label: 'Avg. delivery', color: '#f97316' },
  { value: '4.9★', label: 'App rating', color: '#f5c518' },
];

export default function StatsSection() {
  return (
    <section className="py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden border border-[#222]"
          style={{ background: 'linear-gradient(135deg, #111111 0%, #0d0d0d 100%)' }}>
          {/* Subtle glow top */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-1 bg-gradient-to-r from-transparent via-[#f97316]/40 to-transparent" />
          <div className="px-8 py-7">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats?.map((stat, i) => (
                <div key={i} className="text-center relative">
                  {i < stats?.length - 1 && (
                    <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-8 w-px bg-[#222]" />
                  )}
                  <p
                    className="text-2xl md:text-3xl font-bold mb-1"
                    style={{ color: stat?.color }}
                  >
                    {stat?.value}
                  </p>
                  <p className="text-gray-500 text-xs md:text-sm">{stat?.label}</p>
                </div>
              ))}
            </div>
          </div>
          {/* Subtle glow bottom */}
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-64 h-1 bg-gradient-to-r from-transparent via-[#f5c518]/20 to-transparent" />
        </div>
      </div>
    </section>
  );
}
